import { getAllClassrooms } from '../../api/endpoints/sponte';
import { getAllMatriculas } from '../../api/sponteAPI';
import { aulas_inicio_censo_escolar } from '../../utils/YEARCONSTS';
import { readEnrollmentResponse } from './enrollmentStatistics';
import { summarizeHistoryYear } from './enrollmentHistoryModel';
const cache = new Map();
const CACHE_MS = 5 * 60 * 1000;
async function queryYear(year, unit, isCancelled) {
  const calendar = aulas_inicio_censo_escolar.anoLetivo[year]?.[unit];
  if (!calendar) throw new Error('Calendário não configurado');
  const date = calendar.split('/').reverse().join('/');
  const withTimeout = async request => {
    let timer;
    try {
      return await Promise.race([request, new Promise((_, reject) => {
        timer = setTimeout(() => reject(new Error('Tempo de consulta excedido')), 60000);
      })]);
    } finally {
      clearTimeout(timer);
    }
  };
  const catalog = await withTimeout(getAllClassrooms(year));
  if (isCancelled()) throw new Error('Consulta cancelada');
  if (!Array.isArray(catalog)) throw new Error('Cadastro de turmas indisponível');
  for (const row of catalog) {
    const code = Array.isArray(row.RetornoOperacao) ? row.RetornoOperacao[0] : row.RetornoOperacao;
    if (code && !/^(?:0?1|43)(?:\s*-|\s*$)/.test(code)) throw new Error('Cadastro de turmas não confirmado');
  }
  const responses = await Promise.allSettled([1, 2, 6].map(async status => {
    let timer;
    try {
      const result = await Promise.race([getAllMatriculas(date, status), new Promise((_, reject) => {
        timer = setTimeout(() => reject(new Error('Tempo de consulta excedido')), 60000);
      })]);
      return readEnrollmentResponse(result);
    } finally {
      clearTimeout(timer);
    }
  }));
  if (responses.some(result => result.status === 'rejected')) throw new Error('Ano não confirmado');
  return {
    ...summarizeHistoryYear(responses.flatMap(result => result.value), year, catalog),
    date,
    queriedAt: Date.now()
  };
}

// Uma campanha de cada vez, com no máximo três consultas concorrentes. Erro não é cacheado.
export async function loadEnrollmentHistory({
  years,
  unit,
  force = false,
  onYear,
  isCancelled = () => false
}) {
  for (const year of [...years].reverse()) {
    if (isCancelled()) return;
    const key = `${unit}:${year}`;
    try {
      const cached = cache.get(key);
      const value = !force && cached && Date.now() - cached.queriedAt < CACHE_MS ? cached : await queryYear(year, unit, isCancelled);
      if (isCancelled()) return;
      cache.set(key, value);
      onYear(year, value);
    } catch {
      if (isCancelled()) return;
      onYear(year, {
        error: true
      });
    }
  }
}
